// resources/js/bootstrap.js

import Popper from "popper.js";
import $ from "jquery";
import "bootstrap";
import axios from "axios";

/**
 * Make Popper and jQuery globally available (if you need them on window)
 */
window.Popper = Popper;
window.$ = window.jQuery = $;

/**
 * Configure Axios
 */
window.axios = axios;
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

/**
 * Example of setting a dynamic header from meta tags
 */
const activeCompanyIdMeta = document.head.querySelector(
    'meta[name="active-company-id"]'
);
if (activeCompanyIdMeta) {
    window.axios.defaults.headers.common["X-Salesbyte-Active-Company-Id"] =
        activeCompanyIdMeta.content;
}

/**
 * If using Laravel Echo with Pusher:
 */
import Echo from "laravel-echo";

import Pusher from "pusher-js";
window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: "reverb",
    key: import.meta.env.VITE_REVERB_APP_KEY,
    wsHost: import.meta.env.VITE_REVERB_HOST,
    wsPort: import.meta.env.VITE_REVERB_PORT ?? 80,
    wssPort: import.meta.env.VITE_REVERB_PORT ?? 443,
    forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? "https") === "https",
    enabledTransports: ["ws", "wss"],
});
